export const INVALID_SEED_MSG =
  'It seems you did not save your recovery phrase correctly, please try again';
